import React, { useEffect, useState } from "react";
import { CellProps } from "react-table";
import AgTableInfiniteScroll from "../../../components/AgTableV2InfiniteScroll";
import { TblInboxMessage } from "../../../models";
import { INQUIRY_CONSTANT, OFFERING_TYPE, OFFERING_TYPE_NAME } from "../../../utils/constant";
import {
  formatDateTimeNoSecond,
  formatDateTimeToLocalTime
} from "../../../utils/helper";
import CardMessageMobileTable from "../CardMessageMobileTable";
import { IMailTableProps } from "./mailTable.props";

const SentMailTableView: React.FC<IMailTableProps> = ({
  dataInbox,
  onOpenMessageDetail,
  isLoading,
  getInquiryDetails,
  onClickEdit,
  setDeletedInboxMessageId,
  updateInfoAction,
  onLoadMore,
  maxLength,
  data,
  isClickAddInquiry,
  isClickExportExcel,
  onCloseTrailItem,
  isClickFilterOnMobile,
  ...props
}: IMailTableProps) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobileScreen = screenWidth <= 768;
  const isLargeScreen = screenWidth >= 1024;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "  ",
        width: `${isLargeScreen ? "29%" : "26%"}`,
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;

          return (
            <div className="flex flex-col items-start">
              <p className="text-[14px] text-[#58585B] m-0 p-0">
                {rowData.inboxRecipientsMappings &&
                  `${rowData.inboxRecipientsMappings[0]?.fkToIndividual?.firstName ?? ""} 
                  ${rowData.inboxRecipientsMappings[0]?.fkToIndividual?.lastName ?? ""}${rowData.inboxRecipientsMappings.length > 1 ? ";..." : ""
                  }`}
              </p>
              <p className="text-[12px] text-[#637381] m-0 p-0">
                {rowData.fkInquiryType?.inquiryTypeName ===
                  INQUIRY_CONSTANT.INQUIRY_TYPE_NAME.INSIDE ? (
                  formatDateTimeNoSecond(formatDateTimeToLocalTime(rowData.sendDate))
                ) : (formatDateTimeNoSecond(
                  (() => {
                    const date = new Date(`${rowData?.sendDate}Z`);
                    date.setHours(0, 0, 0, 0);
                    return date;
                  })(),
                ))
                }
              </p>
            </div>
          );
        },
      },
      {
        Header: "Subject",
        width: `${isLargeScreen ? "29%" : "26%"}`,
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;

          return (
            <p className="block max-w-[200px] overflow-hidden text-ellipsis text-nowrap md:whitespace-normal md:line-clamp-1 md:overflow-hidden md:text-ellipsis md:-webkit-box md:-webkit-line-clamp-1 md:-webkit-box-orient-vertical">
              {rowData.subject}
            </p>
          );
        },
      },
      {
        Header: "Offering Type",
        width: "15%",
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;
         let comType =
          rowData.fkComOffering?.fkOfferingType?.offeringTypeName ??
          rowData?.fkInquiry?.fkMainService?.fkOfferingType?.offeringTypeName ??
          rowData?.fkInquiry?.otherNavigation?.offeringTypeName ?? "N/A";;

          return <p className="">{comType}</p>;
        },
      },
      {
        Header: "Status",
        width: "13%",
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;
          let inboxStatus = rowData.fkInquiryStatus?.status ?? "";

          return <p className="">{inboxStatus}</p>;
        },
      },
      {
        Header: " ",
        width: `${isLargeScreen ? "14%" : "20%"}`,
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;

          return (
            <div className="flex gap-4">
              <p
                style={{ color: "#0971A2" }}
                className="inline text-blue-700 hover:cursor-pointer font-bold"
                onClick={() => {
                  getInquiryDetails(rowData.inboxMessageId);
                  onClickEdit(rowData.inboxMessageId);
                }}
              >
                Edit
              </p>
              <p
                style={{ color: "#0971A2" }}
                className="inline text-blue-700 hover:cursor-pointer font-bold"
                onClick={() => {
                  setDeletedInboxMessageId(rowData.inboxMessageId!);
                }}
              >
                Delete
              </p>
            </div>
          );
        },
      },
      // {
      //   Header: "Creation Type",
      //   width: "15%",
      //   Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
      //     const rowData = row.original;
      //     let inboxType = rowData.fkInquiryType?.inquiryTypeName ?? ""

      //     return (
      //       <p className="">{inboxType}</p>
      //     );
      //   },
      // },
      // {
      //   Header: "Action",
      //   width: "15%",
      //   Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
      //     const rowData = row.original;

      //     return (
      //       <>
      //         <a role="button" className="mr-3 focus:ring focus:ring-blue-300 link-redirect">Edit</a>
      //         <a role="button" className="focus:ring focus:ring-blue-300 link-redirect">Delete</a>
      //       </>
      //     );
      //   },
      // },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onClickEdit, screenWidth],
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //md:overflow-auto
  return (
    <div className={`${isMobileScreen ? "mt-[35px]" : ""} `}>
      {isMobileScreen ? (
        <CardMessageMobileTable
          loadMore={onLoadMore}
          data={data ?? []}
          maxLength={dataInbox.maxLength ?? 0}
          isClickOnRow={true}
          onClickOnRow={(e, cell) => onOpenMessageDetail(e, cell)}
          textNoDataFound="No inquiries sent."
          isReceivedTab={false}
          isLoading={isLoading}
          onClickEdit={onClickEdit}
          getInquiryDetails={getInquiryDetails}
          setDeletedInboxMessageId={setDeletedInboxMessageId}
          updateInfoAction={updateInfoAction}
          isClickAddInquiry={isClickAddInquiry}
          isClickExportExcel={isClickExportExcel}
          isClickFilterOnMobile={isClickFilterOnMobile}
          onCloseTrailItem={onCloseTrailItem}
        />
      ) : (
        <AgTableInfiniteScroll
          columns={columns}
          noHeader={true}
          data={data ?? []}
          scrollableTarget="scrollableDiv"
          onLoadMoreData={onLoadMore}
          maxLength={dataInbox.maxLength ?? 0}
          isClickOnRow={true}
          onClickOnRow={(e, cell) => onOpenMessageDetail(e, cell)}
          textNoDataFound="No inquiries sent."
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default React.memo(SentMailTableView);
